import { Cell } from '@silevis/reactgrid';
import { CSSProperties } from 'react';

interface AddCellProps {
  cells: Cell[];
  rowIndex: number;
  colIndex: number;
  Template: any;
  value?: string | number;
  colSpan?: number;
  format?: JSX.Element | null;
  isExceedingBoundaries?: boolean;
  isExceedingWeeklyWeight?: boolean;
  sx?: CSSProperties;
}

const addCell = (props: AddCellProps) => {
  const {
    cells,
    rowIndex,
    colIndex,
    Template,
    value,
    colSpan,
    format,
    isExceedingBoundaries,
    isExceedingWeeklyWeight,
    sx,
  } = props;
  cells?.push({
    rowIndex,
    colIndex,
    Template,
    props: {
      value,
      format,
      isExceedingBoundaries,
      isExceedingWeeklyWeight,
      style: sx,
    }, // Store format separately
    ...((colSpan ?? 1) > 1 && { colSpan }),
  });
};

export default addCell;
